// src/components/Header.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const { pathname } = useLocation();

  return (
    <header className="site-header">
      <div className="header-inner">
        <Link to="/">
          <img
            src={require('../assets/Lotto-Logic-AI-logo-header.png')}
            alt="LottoLogic AI"
            className="header-logo"
          />
        </Link>
        <nav className="header-nav">
          <Link to="/how-it-works" className={pathname === '/how-it-works' ? 'active orange' : ''}>How it Works</Link>
          {/* <Link to="/pricing" className={pathname === '/pricing' ? 'active green' : ''}>
  Pricing
</Link> */}
          <Link to="/faqs" className={pathname === '/faqs' ? 'active blue' : ''}>FAQs</Link>
          <Link to="/login" className={pathname === '/login' || pathname === '/profile' ? 'active yellow' : ''}>Profile</Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
